import React from 'react';
import { Box } from '@mui/material';
import { WalteroCard, WalteroTypography } from '../waltero';
import { formatValue } from '../../utils/reportFormatters';

const SummaryCards = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 2, mb: 3 }}>
      <WalteroCard variant="elevated" sx={{ p: 2, textAlign: 'center' }}>
        <WalteroTypography variant="h6" color="primary" gutterBottom>
          Total Devices
        </WalteroTypography>
        <WalteroTypography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
          {summary.totalDevices}
        </WalteroTypography>
      </WalteroCard>
      
      <WalteroCard variant="elevated" sx={{ p: 2, textAlign: 'center' }}>
        <WalteroTypography variant="h6" color="primary" gutterBottom>
          Devices with Data
        </WalteroTypography>
        <WalteroTypography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
          {summary.devicesWithData}
        </WalteroTypography>
      </WalteroCard>
      
      <WalteroCard variant="elevated" sx={{ p: 2, textAlign: 'center' }}>
        <WalteroTypography variant="h6" color="primary" gutterBottom>
          Total Usage (All Sensors)
        </WalteroTypography>
        <WalteroTypography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
          {formatValue(summary.totalUsage)}
        </WalteroTypography>
      </WalteroCard>
      
      <WalteroCard variant="elevated" sx={{ p: 2, textAlign: 'center' }}>
        <WalteroTypography variant="h6" color="primary" gutterBottom>
          Avg Usage per Day per Sensor
        </WalteroTypography>
        <WalteroTypography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
          {formatValue(summary.avgUsagePerDayPerSensor)}
        </WalteroTypography>
      </WalteroCard>
    </Box>
  );
};

export default SummaryCards;